import { useState } from "react";
import { useSelector } from "react-redux";

import { closePIN, enableEditableDashboard } from "../store/config.dispatch";
import ReactPINField from 'react-pin-field';

import './MyPINField.scss'
import { openAddCard } from "../store/cards.dispatch";

const TPinStatus = {
  login: 'login',
  enterNewPIN: 'enterNewPIN',
  pinSuccess: 'pinSuccess',  
}

export const MyPinField = () => {
  const isVisible = useSelector(state => state.config.visiblePIN);
  const [pinStatus, setPINStatus] = useState(TPinStatus.login);
  const [header, setHeader] = useState('🔒 Enter your PIN');
  const [firstPINSetup, setFirstPINSetup] = useState(false);

  let PIN1;

  const enableDashBoard = () => {
    enableEditableDashboard();
    closePIN();

  }

  const close = () => {
    closePIN();
    setPINStatus(TPinStatus.login);
    if (firstPINSetup) openAddCard();
  }

  const validatePIN = PIN => {
    if ((localStorage.PIN) && (PIN == localStorage.PIN)) {
      enableDashBoard();
    } else if (!(localStorage.PIN) && (PIN === '0000')) {
      setPINStatus(TPinStatus.enterNewPIN);
      setHeader('🔒 Enter a new PIN');
    }
  }

  const validatePIN1 = PIN => {
    PIN1 = PIN;
    if (PIN.length === 4)  document.querySelectorAll('input#pin2')[0].focus()
  }

  const validatePIN2 = PIN => {
    if (PIN === PIN1) {
      // write here the new PIN
      localStorage.PIN = PIN;
      setPINStatus(TPinStatus.pinSuccess);
      setHeader('Congratulations ...');
      setFirstPINSetup(true);
    }
  }

  return isVisible ? (
    <div className="
      MyPINField
      fixed
      z-10
      top-0
      left-0
      w-screen
      h-screen
      flex
      flex-col
      justify-center
      items-center
      bg-c5
    ">
      <div
        className="
          body
          flex
          flex-col
          box-border
          w-11/12
          m-1
          p-4
          rounded-lg
          bg-c5
          border-2
          border-c4
        "
      >
        <h1 className="c1">{header}</h1>

        <div className="flex flex-col mt-4 gap-4">
          {pinStatus === TPinStatus.login && <>
            <div>
              <ReactPINField
                autoFocus
                length={4}
                type="password"
                onChange={validatePIN}
              />
            </div>
            {!localStorage.PIN && <p>Default PIN is 0000</p>}
          </>
          }
          {pinStatus === TPinStatus.enterNewPIN &&
            <>
              <div>
                <ReactPINField
                  autoFocus
                  length={4}
                  type="password"
                  className="h-11 w-8 rounded-xl"
                  onChange={validatePIN1}
                />
              </div>
              <h6 className="c2">Re enter your new PIN</h6>
              <div>
                <ReactPINField
                  id="pin2"
                  length={4}
                  type="password"
                  className="h-12 w-8 rounded-xl"
                  onChange={validatePIN2}
                />
              </div>
            </>
          }
          {pinStatus === TPinStatus.pinSuccess && 
            <div className="flex flex-col items-center">
              <div style={{fontSize: 132}}>😀</div>
              <p>You have succesfully set up a new PIN</p>
            </div>
          }
          <div className="flex justify-end">
            <button
              className="py-3 px-4 rounded-md bg-c1 c5"
              onClick={close}
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  ) : null;
};
